import { ChakraProvider, ThemeConfig } from '@chakra-ui/react'
import React, { FC, useMemo } from 'react'
import './fonts'
import { setupTheme, BodyBackgroundNuance } from './theme'

type TTheme = ReturnType<typeof setupTheme>

interface IThemeProviderProps {
  bodyType: BodyBackgroundNuance
  themeConfig?: ThemeConfig
  children?: React.ReactNode
  extend?: (baseTheme: TTheme) => TTheme
  isAndroid?: boolean
}

const defaultThemeConfig: ThemeConfig = {
  initialColorMode: 'light',
  // Use the following setting only for Electron.
  // For the web, if set to true, the color mode will not be persisted.
  useSystemColorMode: false,
}

const ThemeProvider: FC<IThemeProviderProps> = ({
  themeConfig = defaultThemeConfig,
  extend,
  bodyType = BodyBackgroundNuance.Clean,
  children,
  isAndroid,
}) => {
  const baseTheme = useMemo(
    () => setupTheme(themeConfig, bodyType, isAndroid),
    [themeConfig, bodyType, isAndroid],
  )

  return (
    <ChakraProvider
      resetCSS={true}
      theme={extend !== undefined ? extend(baseTheme) : baseTheme}>
      {children}
    </ChakraProvider>
  )
}

export { ThemeProvider }
